import axios from "axios";
const gallery_apiurl = process.env.VUE_APP_API_URL_GALLERY;


const state = {
  tourPhotos: [],
  tourDayPhotos: [],
  tourGalleryPhotos: [],
  tourInnerPhotos: [],
};

const getters = {
  tourPhotos(state) {
    return state.tourPhotos;
  },

  tourDayPhotos(state) {
    return state.tourDayPhotos;
  },

  tourGalleryPhotos(state) {
    return state.tourGalleryPhotos;
  },

  tourInnerPhotos(state) {
    return state.tourInnerPhotos;
  },
};

const mutations = {
  setTourPhotos(state, photos) {
    state.tourPhotos = photos;
  },

  setTourDayPhotos(state, photos) {
    state.tourDayPhotos = photos;
  },

  setTourGalleryPhotos(state, photos) {
    state.tourGalleryPhotos = photos;
  },

  setTourInnerPhotos(state, photos) {
    state.tourInnerPhotos = photos;
  },
};

const actions = {
  async fetchTourPhotos({ commit, rootState }, filter) {
    const accessToken = rootState.authStore.token;
    let likeFilter = null;

    // filter destination photos
    if (filter) {
      // Convert filter to lowercase
      filter = filter.toLowerCase();
      // Replace every underscore with dash
      filter = filter.replace(/_/g, "-");
      likeFilter = `&like=${filter}`;
    }

    await axios
      .get(`${gallery_apiurl}/gallery?category=tour${likeFilter}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setTourPhotos", res.data);
      });
  },

  async fetchTourDayPhotos({ commit, rootState }, filter) {
    const accessToken = rootState.authStore.token;
    let likeFilter = null;

    // filter destination photos
    if (filter) {
      // Convert filter to lowercase
      filter = filter.toLowerCase();
      // Replace every underscore with dash
      filter = filter.replace(/_/g, "-");
      likeFilter = `&like=${filter}`;
    }

    await axios
      .get(`${gallery_apiurl}/gallery?category=tour_day${likeFilter}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setTourDayPhotos", res.data);
      });
  },

  async fetchTourGalleryPhotos({ commit, rootState }, filter) {
    const accessToken = rootState.authStore.token;
    let likeFilter = null;

    // filter destination photos
    if (filter) {
      // Convert filter to lowercase
      filter = filter.toLowerCase();
      // Replace every underscore with dash
      filter = filter.replace(/_/g, "-");
      likeFilter = `&like=${filter}`;
    }

    await axios
      .get(`${gallery_apiurl}/gallery?category=tour_gallery${likeFilter}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setTourGalleryPhotos", res.data);
      });
  },

  async fetchTourInnerPhotos({ commit, rootState }, filter) {
    const accessToken = rootState.authStore.token;
    let likeFilter = null;

    // filter destination photos
    if (filter) {
      // Convert filter to lowercase
      filter = filter.toLowerCase();
      // Replace every underscore with dash
      filter = filter.replace(/_/g, "-");
      likeFilter = `&like=${filter}`;
    }

    await axios
      .get(`${gallery_apiurl}/gallery?category=tour_inner${likeFilter}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setTourInnerPhotos", res.data);
      });
  },


  async uploadTourPhotoGallery({ rootState }, formData) {
    const accessToken = rootState.authStore.token;

    return await axios.post(`${gallery_apiurl}/tour-photo/upload`, formData, {
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  async uploadTourDayPhotoGallery({ rootState }, formData) {
    const accessToken = rootState.authStore.token;

    return await axios.post(`${gallery_apiurl}/tour-photo-day/upload`, formData, {
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data',
      },
      // onUploadProgress: function (progressEvent) {
      //   console.log(parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100)));
      // }
    });
  },

  async uploadTourGalleryPhotoGallery({ rootState }, formData) {
    const accessToken = rootState.authStore.token;

    return await axios.post(`${gallery_apiurl}/tour-photo-gallery/upload`, formData, {
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  async uploadTourInnerPhotoGallery({ rootState }, formData) {
    const accessToken = rootState.authStore.token;

    return await axios.post(`${gallery_apiurl}/tour-photo-inner/upload`, formData, {
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  async deleteTourPhotoGallery({ rootState }, data) {
    const accessToken = rootState.authStore.token;

    return await axios
      .delete(`${gallery_apiurl}/tour-photo/delete`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        data: data
      });

  },




};

export default {
  state,
  getters,
  actions,
  mutations,
};
